/**
 * The permissions the bank relationship routes declare
 * (`server/internal/cash/bank_relationship_models.go`, `bank_relationship_handler.go`).
 *
 * - `read` — the register, one relationship, its accounts, facilities, contacts, tariffs,
 *   recorded charges, the limit history and both reports;
 * - `manage` — contacts, tariffs, recorded charges, and requesting / withdrawing a change to the
 *   counterparty limit. Deciding a limit loosening happens in the Approvals Inbox; the decider
 *   must also hold `manage` and must not be the requester (the server re-checks both).
 * - `bankAccountRead` — `GET /bank-accounts?bankId=` (follow-up #79): every account at the bank,
 *   not only the live ones the relationship lists, for the record-a-charge picker.
 */
export const BANK_RELATIONSHIP_PERMISSIONS = {
  read: 'cash.bank_relationship.read',
  manage: 'cash.bank_relationship.manage',
  bankAccountRead: 'cash.account.read',
} as const
